// extracted by mini-css-extract-plugin
export default {"heading":"Nu-z","corrected":"Ou-z","redirectVerbiageContainer":"Pu-z","redirectVerbiageText":"Qu-z"};